import ipc from "../../../electron/ipc/ipc"
import { getIDB, setIDB } from "../../../ext/indexedDB"

import { mapGetters, mapActions } from 'vuex'
import { AJAX, BLOB, DLP, CHAT, CHATS, CONTACTS, USERDATA, LOGIN, } from '../../store/modulesNames'
import {
    ACT_ABORT_AJAX_CALL,
    ACT_AJAX_GET_FILE,
    ACT_SEND_FILE_SAVE_EVENT,
    ACT_CHAT_SET_MSG_ENTITIES,
    ACT_CHAT_UPDATE_SCH_MESSAGE,
    ACT_CHAT_LINK_INFO,
} from '../../store/actionsTypes'
import { DLP_SOURCE_TYPES } from '../../store/modules/dlp'
import {
    GET_AJAXX_CALL_IS_EXIST_BY_FILE,
    GET_AJAXX_CALL_PROGRESS_BY_FILE,
    GET_FILE_BLOB,
    GET_SELECTED_CHAT,
    GET_MY_CONTACT,
    GET_MERGED_CONTACT_BY_ID,
    GET_IS_ROLES_SUPPORTED,
    GET_CHAT_ITEM_TEXT,
    GET_APP_REDIRECTED_SERVER,
    GET_SERVER_REMOTE_HOST,
    GET_CHAT_SCH_MESSAGE_BY_ID,
    GET_SERVER_API,
    GET_CHAT_EDIT_MESSAGE_ID,
    GET_CHAT_REPLY_MESSAGE_ID,
    GET_CHAT_REPLY_QUOTE,
    GET_HOST,
    GET_UID,
} from '../../store/gettersTypes'

import moment from 'moment'

import Logger from '../../common/Logger'
const logger = new Logger('chat-message-mixin')

const RE_VM_CONF_LINK = /\S*?\/service\/join\/\?confid=\S*/g
const RE_ROSCHAT_CONF_LINK = /\S*?\/join\/\?meetingid=\S*/g
const RE_ROSCHAT_GROUP_LINK = /\S*?\/joinGroup\/\?link=(?<groupUrlString>[^\s\]]+)\S*/m
const VM_CONF_REGEX = new RegExp(RE_VM_CONF_LINK)
const RC_CONF_REGEX = new RegExp(RE_ROSCHAT_CONF_LINK)
const ROSCHAT_GROUP_LINK_REGEX = new RegExp(RE_ROSCHAT_GROUP_LINK)

const urlPreviews = new Map(), MAX_UPDATED_TIME = 60 * 60 * 24

const maxCharsWithShortMessage = 1000

import hljs from 'highlight.js'
import * as UTIF from '../../../ext/UTIF'

const mixin = {
    computed: {
        isAjaxCookiesSupported() {
            return this[GET_SERVER_API] >= declarations.serverAPILevels.LEVEL_17
        },
        xhrFile() { return this.message && this.message.msg && this.message.msg.file },
        xhrId() { return this.xhrFile && this[GET_AJAXX_CALL_IS_EXIST_BY_FILE](this.xhrFile) },
        isPending() { return this[GET_AJAXX_CALL_IS_EXIST_BY_FILE](this.xhrFile) },
        loadProgress() { return this[GET_AJAXX_CALL_PROGRESS_BY_FILE](this.xhrFile) },
        link() { return this[GET_FILE_BLOB](this.xhrFile) },
        isRolesModelSupported() {
            return this[GET_IS_ROLES_SUPPORTED]
        },
        myContactActions() {
            return this[GET_MY_CONTACT].actions || []
        },
        isWithPreview() {
            return this.message && this.message.msg && this.message.msg.previewFile
        },
        getChatContact() {
            const cid = this[GET_SELECTED_CHAT] && this[GET_SELECTED_CHAT].cid
            if (!cid) return {}
            return this[GET_MERGED_CONTACT_BY_ID](cid)
        },
        getAllowedActions() {
            return this.getChatContact && this.getChatContact.actions || {}
        },
        isSendMediaMessage() {
            if (!this.isRolesModelSupported) return true
            let isAllowed = true
            if (this.myContactActions.hasOwnProperty('send-media-message')) isAllowed = this.myContactActions['send-media-message']
            if (this.cidType === declarations.chatTargetTypes.CHAT_TARGET_TYPE_GROUP) return isAllowed
            if (this.getAllowedActions.hasOwnProperty('send-media-message')) isAllowed = isAllowed && this.getAllowedActions['send-media-message']
            return isAllowed
        },
        textMsg() {
            return this.message && this.message.msg || ''
        },
        captionText() {
            let message = this.message, msg
            if (message.fileGroupId && message.startFileGroup) {
                msg = message.groupMsgs[message.groupMsgs.length - 1]
            } else if (!message.fileGroupId) msg = message.msg
            return msg && msg.text || ''
        },
        captionText() {
            let message = this.message, msg
            if (message.fileGroupId && message.startFileGroup) {
                msg = message.groupMsgs[message.groupMsgs.length - 1]
            } else if (!message.fileGroupId) msg = message.msg
            return msg && msg.text || ''
        },
        isSystemMsgType() {
            // console.log("🚀 ~ chat-message-mixin.js:76 ~ isSystemMsgType ~ this.message:", this.message)
            return this.message && this.message.type === 'system'
        },
        isSchMessage() {
            return this.message && this.message.isScheduledMsg
        },
        textEntities() {
            return this.message && this.message.entities || []
        },
        textContinue() {
            return this.shortMsg && (this.textMsg.length > maxCharsWithShortMessage ||
                this.captionText.length > maxCharsWithShortMessage)
        },
        chatReplyMessage() {
            return this[GET_CHAT_REPLY_MESSAGE_ID]()
        },
        chatEditMessage() {
            return this[GET_CHAT_EDIT_MESSAGE_ID]()
        },
        chatQuote() {
            return this[GET_CHAT_REPLY_QUOTE]
        },
        hostUrl() {
            return this[GET_HOST] + '/'
        },
        chatLinkUrl() {
            return `${this.hostUrl}joinGroup/?link=${this.groupLinkStr()}`
        },
        ...mapGetters(LOGIN, [GET_SERVER_API]),
        ...mapGetters(AJAX, [GET_AJAXX_CALL_IS_EXIST_BY_FILE, GET_AJAXX_CALL_PROGRESS_BY_FILE]),
        ...mapGetters(BLOB, [GET_FILE_BLOB]),
        ...mapGetters(CHATS, [GET_SELECTED_CHAT]),
        ...mapGetters(CHAT, [
            GET_CHAT_ITEM_TEXT,
            GET_CHAT_SCH_MESSAGE_BY_ID,
            GET_CHAT_EDIT_MESSAGE_ID,
            GET_CHAT_REPLY_MESSAGE_ID,
            GET_CHAT_REPLY_QUOTE,
        ]),
        ...mapGetters(CONTACTS, [GET_MY_CONTACT, GET_MERGED_CONTACT_BY_ID, GET_IS_ROLES_SUPPORTED]),
        ...mapGetters(USERDATA, [GET_APP_REDIRECTED_SERVER]),
        ...mapGetters(LOGIN, [GET_SERVER_API]),
        ...mapGetters(USERDATA, [GET_HOST, GET_UID]),
    },
    methods: {
        abortAjaxCall() {
            if (this.xhrId) this[ACT_ABORT_AJAX_CALL](this.xhrId)
        },
        withPreview(type) {
            return ['video', 'image'].includes(type)
        },
        async getPreview(msg, remoteHost = '') {
            let preview
            let previewFile = msg.previewFile
            if (remoteHost) {
                preview = `https://${remoteHost}` + '/' + declarations.http_post_dirs.CHAT_DATA_DIR + previewFile
                return preview
            }
            let storedPreview = false
            const previewFilePath = declarations.http_post_dirs.CHAT_DATA_DIR + previewFile
            const isTiff = msg && (msg.extension.indexOf('tif') > -1 || msg.extension === 'dng')
            if (isTiff) previewFile = msg.file
            try {
                storedPreview = await getIDB(previewFilePath, msg) || await this.getDB_Preview(previewFile, msg)
            } catch (error) { }
            const isBlob = storedPreview instanceof Blob
            if (!isBlob && typeof storedPreview === 'string') return storedPreview
            const isImageBlob = isBlob && (storedPreview.type === "application/image" || storedPreview.type === "application/octet-stream")
            if (storedPreview && isImageBlob) {
                return this.getObjectURL(storedPreview)
            }
            if (previewFile) {
                preview = !isTiff ? this.$store.getters['userdata/getHost'] + '/' + previewFilePath :
                    this.$store.getters['userdata/getHost'] + '/' + previewFile
                try {
                    if (!isTiff) this.setDB_Preview(msg.previewFile, preview)
                    return preview
                } catch (e) {
                    console.log("🚀 ~ chat-message-mixin.js ~ getPreview ~ e:", e)
                    return preview
                }
            }
            else if (msg.preview) return 'data:image/png;base64,' + msg.preview
        },
        async getDB_Preview(previewFile, msg) {
            const storedFile = await getIDB(previewFile)
            return storedFile
        },
        async setDB_Preview(key, preview) {
            const blobFile = await this.getBlobFromURL(preview)
            if (blobFile) setIDB(key, blobFile)
        },
        getObjectURL(storedPreview) {
            window.URL.revokeObjectURL(storedPreview)
            return window.URL.createObjectURL(storedPreview)
        },
        async getGifPreview(msg, remoteHost = '') {
            const storedPreview = await getIDB(msg.file)
            if (storedPreview) {
                window.URL.revokeObjectURL(storedPreview)
                return window.URL.createObjectURL(storedPreview)
            }
            if (msg.previewFile) {
                let preview
                if (remoteHost) {
                    preview = `https://${remoteHost}` + '/' + declarations.http_post_dirs.CHAT_DATA_DIR + msg.previewFile
                }
                else preview = this.$store.getters['userdata/getHost'] + '/' + msg.file
                const blobFile = await this.getBlobFromURL(preview)
                setIDB(msg.file, blobFile)
                return preview
            }
        },
        async getTiffPreview(fetchRes, cachedPreview = '', file = null, remoteHost = '') {
            // console.log("🚀 ~ chat-message-mixin.js:167 ~ getTiffPreview ~ file:", file)
            if (file) {
                let storedPreviewSrc = await getIDB(file)
                if (storedPreviewSrc) {
                    // console.log("🚀 ~ chat-message-mixin.js:170 ~ getTiffPreview ~ storedPreviewSrc:", storedPreviewSrc)
                    // const mimetype = storedPreview.type
                    // console.log("🚀 ~ chat-message-mixin.js:198 ~ getTiffPreview ~ mimetype:", mimetype)
                    // if (mimetype !== 'image/png') storedPreview = storedPreview.slice(0, storedPreview.size, 'image/png')
                    // console.log("🚀 ~ chat-message-mixin.js:200 ~ getTiffPreview ~ storedPreview:", storedPreview)
                    // window.URL.revokeObjectURL(storedPreview)
                    return storedPreviewSrc
                }
            }
            const arrBuffer = await fetchRes.arrayBuffer()
            const pages = UTIF.decode(arrBuffer)
            UTIF.decodeImage(arrBuffer, pages[0])
            const rgba = UTIF.toRGBA8(pages[0])
            // console.log("🚀 ~ chat-message-mixin.js:177 ~ getTiffPreview ~ rgba:", rgba)
            console.log(pages[0].width, pages[0].height, pages[0])

            const canvas = document.createElement('canvas');
            canvas.width = pages[0].width;
            canvas.height = pages[0].height;
            const ctx = canvas.getContext('2d');
            const imageData = ctx.createImageData(canvas.width, canvas.height);
            for (let i = 0; i < rgba.length; i++) {
                imageData.data[i] = rgba[i];
            }
            ctx.putImageData(imageData, 0, 0);
            const _src = canvas.toDataURL('image/png')
            // console.log("🚀 ~ chat-message-mixin.js:188 ~ getTiffPreview ~ _src:", _src)
            if (cachedPreview) {
                // let blobFile = await this.getBlobFromURL(cachedPreview)
                // console.log("🚀 ~ chat-message-mixin.js:190 ~ getTiffPreview ~ blobFile:", blobFile)
                // const mimetype = blobFile.type
                // console.log("🚀 ~ chat-message-mixin.js:198 ~ getTiffPreview ~ mimetype:", mimetype)
                // if (mimetype !== 'image/png') blobFile = blobFile.slice(0, blobFile.size, 'image/png')
                // console.log("🚀 ~ chat-message-mixin.js:200 ~ getTiffPreview ~ blobFile:", blobFile)
                if (file && _src) setIDB(file, _src)
            }
            return _src
        },
        getDownloadFileName(type, name, extension) {
            let filename = name + (extension ? '.' + extension : '')
            let date = moment().format('YYYY-MM-DD_HH-MM-SS')
            if (!name || !filename) filename = (type + '_' + date) + (extension ? '.' + extension : '')
            filename = filename && filename.replace(/:/g, '_') // fix file name for Windows
            return filename
        },
        async downloadFile(message, isSaveFile = false) {
            let link = this.$store.getters['blob/getFileBlob'](message.msg.file)
            let fileName = this.getDownloadFileName(message.sub_type, message.msg.name, message.msg.extension)
            // #if process.env.WEBPACK_BUILD_TARGET === 'web'
            let a = document.createElement('a')
            a.setAttribute('href', link)
            a.setAttribute('download', fileName)
            let evt = document.createEvent('MouseEvents')
            evt.initMouseEvent('click', true, true, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null)
            a.dispatchEvent(evt)
            // #endif

            // #if process.env.WEBPACK_BUILD_TARGET === 'electron'
//             let params = {}
//             const uid = message.id + '-' + message.msg.file.match(/(?<=\/data\/).+(?=\.)/)[0] // link && link.replace('blob:file:///', '')
//             let fileKey
//             if (uid) fileKey = 'FilePath:' + uid + fileName
//             else fileKey = 'FilePath:' + fileName
// 
// 
//             let storedPath
//             try {
//                 storedPath = await getIDB(fileKey)
//             } catch { }
//             if (storedPath && !isSaveFile) {
//                 params.fpath = storedPath
//                 try {
//                     let openedFilePath = await ipc.sendAsync('open-file', params)
//                     setIDB(fileKey, openedFilePath)
//                     return true
//                 } catch (e) {
//                     logger.error(e, 'open-file-path error')
//                 }
//             }
//             let fileBlob = await this.getBlobFromURL(link)
//             const reader = new FileReader()
//             reader.onload = async () => {
//                 if (reader.readyState == 2) {
//                     let buffer = Buffer.from(reader.result)
//                     params = { fileName, buffer }
//                     try {
//                         const savedFilePath = await ipc.sendAsync('download-file', params)
//                         if (savedFilePath) {
//                             setIDB(fileKey, savedFilePath)
//                         }
//                     } catch (e) {
//                         logger.error(e, 'download-file error')
//                     }
//                 }
//             }
//             try {
//                 reader.readAsArrayBuffer(fileBlob)
//             } catch (e) {
//                 logger.error(e, 'File read error')
//             }
            // #endif
            this.$store.dispatch(`${DLP}/${ACT_SEND_FILE_SAVE_EVENT}`, {
                fileName: message.msg.file,
                sourceType: DLP_SOURCE_TYPES.CHAT_MESSAGE,
                sourceData: {
                    id: message.id,
                    cid: message.cid,
                    cidType: message.cidType,
                }
            })
        },
        async checkSavedFileExists(message) {
            let result = { storedPath: '', checkResult: false }
            // #if process.env.WEBPACK_BUILD_TARGET === 'electron'
//             let fileName = this.getDownloadFileName(message.sub_type, message.msg.name, message.msg.extension)
//             const uid = message.id + '-' + message.msg.file.match(/(?<=\/data\/).+(?=\.)/)[0] // link && link.replace('blob:file:///', '')
//             let fileKey
//             if (uid) fileKey = 'FilePath:' + uid + fileName
//             else fileKey = 'FilePath:' + fileName
//             try {
//                 result.storedPath = await getIDB(fileKey)
//                 result.checkResult = await ipc.sendAsync('check-file-exists', result.storedPath)
//             } catch { }
            // #endif
            return result
        },
        showFileInFolder(fpath) {
            // #if process.env.WEBPACK_BUILD_TARGET === 'electron'
//             ipc.sendAsync('show-file-in-folder', fpath)
            // #endif
        },
        checkOldRefsFormat(text) {
            const isOldRefFormat = text.search(/^@\[|\s@\[/) > -1
            const isOldBotRefFormat = text.search(/(^|[^\S])(?<command>\/(?!\/)\S+)/) > -1
            if (isOldRefFormat || isOldBotRefFormat) return true
            return false
        },
        setEmojisSpecialStyles(text) {
            let dom = new DOMParser().parseFromString(text, 'text/html')
            let emos = dom.querySelectorAll('.emoji.emojibgrd')
            const emoCount = emos.length
            let span = dom.getElementsByTagName("span")[0]
            emos.forEach((emo, index) => {
                let emoStyle = emo.style
                emoStyle.verticalAlign = "middle"
                if (emoCount === 1) {
                    emoStyle.transform = "scale(2)"
                    span.style = `line-height: 2.6em;`
                    emoStyle.marginLeft = "0.6em"
                    emoStyle.marginRight = "0.4em"
                }
                if (emoCount === 2) {
                    emoStyle.transform = "scale(1.6)"
                    span.style = `line-height: 2.2em;`
                    emoStyle.marginLeft = "0.2em"
                    if (index > 0) {
                        emoStyle.marginLeft = "1em"
                        emoStyle.marginRight = "0.1em"
                    }
                }
                if (emoCount === 3) {
                    emoStyle.transform = "scale(1.3)"
                    span.style = `line-height: 1.8em;`
                    emoStyle.marginLeft = "0.2em"
                    if (index > 0) emoStyle.marginLeft = "0.6em"
                }
            });
            return dom.body.innerHTML
        },
        msgTextHtml(text, entities, isPub = false) {
            if (!text) return ''
            if (typeof text === 'object') return text
            text = text.replace(/</g, '\x7F').replace(/>/g, '\x8F')
            if (entities && entities.length) {
                text = this.messageTextFormat(entities, text)
            } else {
                if (this.isSystemMsgType && !this.isSchMessage) return text
                if (this.isSystemMsgType && this.isSchMessage) return this.$t('chat.scheduled-on') + text
                if (this.checkOldRefsFormat(text)) { // todo as of 21.08.25
                    // const { resultedText, addEntities } = this.convertOldRefsToNewFormat(text, true)
                    // console.log("🚀 ~ chat-message-mixin.js:295 ~ msgTextHtml ~ addEntities:", addEntities)
                    // console.log("🚀 ~ chat-message-mixin.js:295 ~ msgTextHtml ~ resultedText:", resultedText)
                    // text = this.messageTextFormat(addEntities, resultedText)
                    text = this.lookForLinks(text)
                }
            }

            let parser = new DOMParser()
            let dom = parser.parseFromString(text, 'text/html')
            if (!isPub) {
                let imgEmojisArr = this.getEmojiNative(text)
                let emoCount = imgEmojisArr ? imgEmojisArr.length : 0

                let textLength = dom.body.textContent.length
                if (emoCount && !isPub && (textLength === 2 * emoCount || textLength === emoCount)) {
                    text = this.wrapEmoji(`<span>` + text + `<\span>`)
                    text = this.setEmojisSpecialStyles(text)
                }
                else if (emoCount) text = this.wrapEmoji(text)
                this.msgTextLength = textLength + emoCount
            } else this.msgTextLength = text.length

            if (this.textContinue) {
                text = this.getSlicedText(dom) + '<span>...</span>'
            }

            if (!this.textContinue) {
                const indentSpan = `<span ${this.$options._scopeId} class="${this.textIndentClasses}"></span>`
                text += indentSpan
            }

            const codeBlockRE = /<div\s+class="codeblock">(.*?)<\/div>/gs
            let codeMatches
            while ((codeMatches = codeBlockRE.exec(text)) !== null) {
                text = text.replace(codeMatches[0], `<div class="code">` + hljs.highlightAuto(codeMatches[1].replace(/&lt;/g, '<').replace(/&gt;/g, '>')).value + `</div>`)
            }
            
            this.withText = true
            text = text.replace(/\x7F/g, '&lt;').replace(/\x8F/g, '&gt;')
            return text
        },
        getSlicedText(dom) {
            let path = [dom.body.childNodes[0]]
            let maxChars = maxCharsWithShortMessage
            let chars = 0
            let pop = false
            let full = false
            while (path.length) {
                let node = path[path.length - 1]
                if (!pop && !full) {
                    if (node.nodeType === Node.TEXT_NODE) {
                        let len = node.textContent.length
                        if (chars + len >= maxChars) {
                            if (chars + len !== maxChars) {
                                let sliceVal = node.textContent.slice(0, maxChars - chars)
                                node.textContent = sliceVal
                            }
                            full = true
                        }
                        chars += node.textContent.length
                    } else if (node.classList[0] === 'emoji') {
                        chars += 1
                        if (chars >= maxChars) full = true
                    } else if (node.nodeType === 1) {
                        let childs = node.childNodes
                        let textChildNode = childs[0] && childs[0].nodeType === Node.TEXT_NODE ? childs[0] : null
                        if (textChildNode) {
                            let len = textChildNode.textContent.length
                            if (chars + len >= maxChars) {
                                if (chars + len !== maxChars) {
                                    let sliceVal = textChildNode.textContent.slice(0, maxChars - chars)
                                    textChildNode.textContent = sliceVal
                                }
                                chars += len
                                full = true
                            }
                        }
                        if (chars >= maxChars) full = true
                    }
                }
                if (!pop && node.childNodes.length) {
                    let child = node.childNodes[0]
                    path.push(child)
                } else if (node.nextSibling) {
                    let child = node.nextSibling
                    if (full) {
                        child.remove()
                    } else {
                        path.splice(path.length - 1, 1, child)
                    }
                } else {
                    path.pop()
                    pop = true
                    continue
                }
                pop = false
            }
            return dom.body.innerHTML
        },
        captionHtml(message) {
            let text = this.captionText
            let _entities = message.entities || []
            if (!text) return ''
            let _outText = ''
            if (_entities.length) {
                _outText = text
            } else {
                const { outText, entities } = this.extractInputTextFormat(text)
                _outText = outText
                _entities = entities
            }
            return this.msgTextHtml(_outText, _entities)
        },
        async loadMessageFile(params, cb) {
            let storedFile
            try {
                storedFile = await getIDB(params.file)
                storedFile = await getIDB(params.file)
            } catch { }
            if (storedFile) {
                const isBlob = storedFile instanceof Blob
                if (!isBlob) storedFile = await this.getBlobFromURL(storedFile)
                window.URL.revokeObjectURL(storedFile)
                const blob_url = window.URL.createObjectURL(storedFile)
                this.$store.commit('blob/updateFileBlob', {
                    file_name: params.file,
                    link: blob_url
                })
                cb && cb()
            } else {
                try {
                    let blobFile = this.$store.getters['blob/getFileBlob'](params.file)
                    if (blobFile) cb && cb()
                    storedFile = await this[ACT_AJAX_GET_FILE]({ url: params.file, remoteHost: params.remoteHost, fileSize: params.size, encKey: params.key, link: true })
                    setIDB(params.file, storedFile)
                    cb && cb()
                } catch (e) {
                    logger.info('get file error')
                }
            }
        },
        async getBlobFromURL(url) {
            try {
                let objParams = {}
                if (this.isAjaxCookiesSupported) objParams = { credentials: "include" }
                let fetchRes = await fetch(url, objParams)
                if (fetchRes && fetchRes.ok) return await fetchRes.blob()
                return null
            } catch (error) {
                return null
            }
        },
        setWindowProtection(isProtected) {
            // #if process.env.WEBPACK_BUILD_TARGET === 'electron'
//             ipc.send('protect-window', { window: 'mainWindow', isProtected })
            // #endif
        },     
        _getFio(cid) {
            return (this.$store.getters["contacts/getMergedContactById"](cid).fio || "")
        },
        _getItemText(message) {
            let text = ''
            switch (message.dataType) {
                case declarations.msgDataTypes.MSG_DATA_TYPE_TEXT:
                    text = message.data
                    break
                case declarations.msgDataTypes.MSG_DATA_TYPE_DATA:
                    text = this._getDataText(message.data)
                    break
                case declarations.msgDataTypes.MSG_DATA_TYPE_UNSTORED:
                    text = message.data
                    break
                case declarations.msgDataTypes.MSG_DATA_TYPE_SYSTEM:
                    text = ""
                    break
                default:
                    text = ""
            }
            return text
        },
        _getDateTime(details) {
            return (details.sentDate + ' ' + details.sentTime) || ''
        },
        _getDataTypeName(type) {
            switch (type) {
                case declarations.msgDataSubTypes.MSG_DATA_SUB_TYPE_IMAGE:
                    return this.$t('image')
                case declarations.msgDataSubTypes.MSG_DATA_SUB_TYPE_VIDEO:
                    return this.$t('video')
                case declarations.msgDataSubTypes.MSG_DATA_SUB_TYPE_FILE:
                    return this.$t('file')
                case declarations.msgDataSubTypes.MSG_DATA_SUB_TYPE_AUDIO:
                    return this.$t('audio')
                case declarations.msgDataSubTypes.MSG_DATA_SUB_TYPE_CONTACT:
                    return this.$t('contact')
                case declarations.msgDataSubTypes.MSG_DATA_SUB_TYPE_LOCATION:
                    return this.$t('mainPage.location')
                case declarations.msgDataSubTypes.MSG_DATA_SUB_TYPE_CHANNEL:
                    return this.$t('channel')
                case declarations.msgDataSubTypes.MSG_DATA_SUB_TYPE_PUBLICATION:
                    return this.$t('publication')
                case declarations.msgDataSubTypes.MSG_DATA_SUB_TYPE_POLL:
                    return this.$t('poll')
                default:
                    return false
            }
        },
        _getDataText(data) {
            let text = ''
            switch (data.type) {
                case declarations.msgDataSubTypes.MSG_DATA_SUB_TYPE_CONTACT:
                    const fields = Array.isArray(data.fields) && data.fields
                    const phones = fields && fields.filter(f => f.type === "phone" || f.type === "workphone")
                    const phone = phones && phones.length && phones[0].value
                    const mails = fields && fields.filter(f => f.type === "mail")
                    const mail = mails && mails.length && mails[0].value
                    const fio = (fields && fields.fio) || phone || mail
                    text = fio
                    break
                case declarations.msgDataSubTypes.MSG_DATA_SUB_TYPE_CHANNEL:
                    text = data.text
                    break
                case declarations.msgDataSubTypes.MSG_DATA_SUB_TYPE_PUBLICATION:
                    return ''
                case declarations.msgDataSubTypes.MSG_DATA_SUB_TYPE_LOCATION:
                    text = data.longitude + " " + data.latitude
                    break
                case declarations.msgDataSubTypes.MSG_DATA_SUB_TYPE_VIDEO:
                case declarations.msgDataSubTypes.MSG_DATA_SUB_TYPE_AUDIO:
                case declarations.msgDataSubTypes.MSG_DATA_SUB_TYPE_FILE:
                case declarations.msgDataSubTypes.MSG_DATA_SUB_TYPE_IMAGE:
                    text = data && data.hasOwnProperty("text") ? data.text : '' || ''
                    break
                case declarations.msgDataSubTypes.MSG_DATA_SUB_TYPE_POLL:
                    text = data.topic
                    break
                case declarations.msgDataSubTypes.MSG_DATA_SUB_TYPE_TEXT:
                    text = data.text
                    break
                default:
                    text = ""
            }
            return text
        },
        async getUrlPreviewBlock(url) {
            if (ROSCHAT_GROUP_LINK_REGEX.test(url) || VM_CONF_REGEX.test(url) || RC_CONF_REGEX.test(url)) return { url: '', title: '', description: '', image: '' }
            if (urlPreviews.has(url)) {
                const currentTimeSec = +new Date() / 1000
                const savedObj = urlPreviews.get(url)
                const { updated } = savedObj
                if ((currentTimeSec - updated) > MAX_UPDATED_TIME) urlPreviews.delete(url)
                else return savedObj
            }
            const host = this[GET_APP_REDIRECTED_SERVER]
            let proxyUrl = `${host}/proxy?url=${url}`
            try {
                const response = await fetch(proxyUrl)
                let data = await response.text()
                const parser = new DOMParser()
                const doc = parser.parseFromString(data, 'text/html')
                const titleTextContent = doc.querySelector('title')?.textContent || ''
                const title = titleTextContent.length > 100 ? titleTextContent.slice(0, 200) + ' ...' : titleTextContent
                const descriptionContent = doc.querySelector('meta[name="description"]')?.getAttribute('content') || ''
                let description = descriptionContent.length > 100 ? descriptionContent.slice(0, 100) + ' ...' : descriptionContent
                if (description === title) description = ''
                const image = doc.querySelector('meta[property="og:image"]')?.getAttribute('content') || ''
                const previewObj = { url, title, description, image, updated: +new Date() / 1000 }
                urlPreviews.set(url, previewObj)
                return previewObj
            } catch (e) {
                return { url: '', title: '', description: '', image: '' }
            }
        },
        getDateItem(prev, cur) {
            let prev_date, cur_date
            if (cur && cur.isScheduledMsg) {
                // const _testTime = date_helper.unixTimeToDateTimeFormatFull(cur.time)
                // console.log("🚀 ~ chat-message-mixin.js:549 ~ getDateItem ~ _testTime:", _testTime)
                if (prev && prev.time) prev_date = date_helper.unixTimeToDateFormat(prev.time)
                cur_date = date_helper.unixTimeToDateFormat(cur.time)
                // cur.dateTime = moment.unix(cur.time).format('YYYY-MM-DD HH:mm:ss')
                // console.log("🚀 ~ chat-message-mixin.js:555 ~ getDateItem ~ cur:", cur)
            } else {
                prev_date = date_helper.secondsLeftToDateFormat(prev && prev.time)
                cur_date = date_helper.secondsLeftToDateFormat(cur.time)
            }
            if (!prev || prev_date !== cur_date) {
                return {
                    senderId: 0,
                    type: 'system',
                    sub_type: 'time',
                    msg: cur_date,
                    side: 'center',
                    classes: ['system-message', 'side-center', 'time'],
                }
            }
        },
        getMessageItem(message) {
            if (!message) return
            const _message = JSON.parse(JSON.stringify(message))
            const cid = message.cid
            const isGroupChat = message.cidType === declarations.chatTargetTypes.CHAT_TARGET_TYPE_GROUP
            const contact = this[GET_MERGED_CONTACT_BY_ID](cid)
            let remoteServerId = contact && contact.objectId
            if (isGroupChat) {
                const externalContact = this[GET_MERGED_CONTACT_BY_ID](message.senderId)
                remoteServerId = externalContact && externalContact.objectId
            }
            const isScheduledMsg = message && message.isScheduledMsg
            let out = message.type === 'out' || app.getUid() === message.senderId
            let time = !isScheduledMsg ? date_helper.secondsLeftToTimeFormat(message.time) : date_helper.unixTimeToTimeFormat(message.time)
            const _dateTime = isScheduledMsg ? message.dateTime : message.timeDetails && message.timeDetails.fullTime
            const status = out ? this.getMessageStatus(message) : ''
            const isPollId = message.data && message.data.hasOwnProperty('pollId') || false
            if (isPollId) message.data.type = 'poll'
            const returnObj = {
                id: message.id,
                cid,
                cidType: message.cidType,
                senderId: message.senderId,
                author: message.author,
                isNote: cid === message.senderId,
                type: message.dataType,
                sub_type: message.data && message.data.type,
                time,
                unixTime: _message.time,
                dateTime: _dateTime,
                msg: this[GET_CHAT_ITEM_TEXT]({ message }),
                fields: message.data && message.data.fields || [],
                entities: message.data && message.data.entities,
                ownMsg: out,
                status,
                sentTime: message.timeDetails && message.timeDetails.sentTime || time,
                keyboard: message.data && message.data.keyboard,
                replyId: isScheduledMsg ? message.payload.data.replyId || 0 : message.replyId,
                replyQuote: message.replyQuote,
                edited: 'editedTime' in message,
                previewSize: message.data && message.data.previewSize,
                remoteServerHost: remoteServerId && message.type !== 'out' ? app.store.getters[`${USERDATA}/${GET_SERVER_REMOTE_HOST}`](remoteServerId) : false,
                reactions: message.reactions || [],
                comments: message.comments || 0,
                commentsSubscribed: message.commentsSubscribed || false,
                commentId: 0,
                isScheduledMsg: isScheduledMsg
            }
            if (message.data && message.data.fileGroupId) returnObj.fileGroupId = message.data.fileGroupId
            if (message && message.commentId) returnObj.commentId = message.commentId
            if (message.localId) returnObj.localId = message.localId
            if (message.isScheduledMsg) returnObj.schUnixTime = message.time
            return returnObj
        },
        getMessageData(inText) {
            const { outText, entities } = this.extractInputTextFormat(inText)
            return JSON.stringify({ type: declarations.msgDataTypes.MSG_DATA_TYPE_TEXT, text: outText, entities })
        },
        getMessageStatus(message) {
            // if (!message.watchedTime && !message.receivedTime && message.status === 'sending') return message.status
            if (!message.watchedTime && !message.receivedTime && message.status) return message.status
            if (message.watchedTime !== undefined) return 'watched'
            if (message.receivedTime !== undefined) return 'received'
            return ''
        },
        getMsgNameByType(message) {
            let msg
            const isSchMsg = this.message && this.message.isScheduledMsg
            switch (message.sub_type) {
                case declarations.msgDataSubTypes.MSG_DATA_SUB_TYPE_IMAGE:
                    msg = this.$t('image')
                    if (message.msg.text) msg = msg + ': ' + message.msg.text
                    return msg
                case declarations.msgDataSubTypes.MSG_DATA_SUB_TYPE_VIDEO:
                    msg = this.$t('video')
                    if (message.msg.text) msg = msg + ': ' + message.msg.text
                    return msg
                case declarations.msgDataSubTypes.MSG_DATA_SUB_TYPE_FILE:
                    msg = this.$t('file')
                    let _fileName = message.msg.name
                    let _extension = message.msg.extension ? '.' + message.msg.extension : ''
                    let fileName = _fileName + _extension
                    let text = message.msg.text || ''
                    msg = msg + ': ' + fileName + ' ' + text
                    return msg
                case declarations.msgDataSubTypes.MSG_DATA_SUB_TYPE_AUDIO:
                    msg = this.$t('audio')
                    if (message.msg.text) msg = msg + ': ' + message.msg.text
                    return msg
                case declarations.msgDataSubTypes.MSG_DATA_SUB_TYPE_CONTACT:
                    return this.$t('contact')
                case declarations.msgDataSubTypes.MSG_DATA_SUB_TYPE_LOCATION:
                    return this.$t('mainPage.location')
                case declarations.msgDataSubTypes.MSG_DATA_SUB_TYPE_CHANNEL:
                    return this.$t('channel')
                case declarations.msgDataSubTypes.MSG_DATA_SUB_TYPE_PUBLICATION:
                    return this.$t('publication')
                case declarations.msgDataSubTypes.MSG_DATA_SUB_TYPE_POLL:
                    return this.$t('poll')
                case declarations.msgDataSubTypes.MSG_DATA_SUB_TYPE_CALL_AVAILABILITY:
                    return this.$t('chat.abonentIsAvailable')
                case declarations.msgDataSubTypes.MSG_DATA_SUB_TYPE_TEXT:
                    return this.getHtml(message.msg)
            }
        },
        getHtml(text) {
            let sanitized_text = text.replace(/</g, '&lt;').replace(/>/g, '&gt;')
            return this.wrapEmoji(this.lookForRefs(sanitized_text))
        },
        isGroupLink(message) {
            // console.log("🚀 ~ chat-message-mixin.js:800 ~ isGroupLink ~ message:", message)
            const msg = message.msg, entities = message.entities
            // console.log("🚀 ~ chat-message-mixin.js:801 ~ isGroupLink ~ msg:", msg)
            // console.log("🚀 ~ chat-message-mixin.js:802 ~ isGroupLink ~ entities:", entities)
            if (typeof msg === 'object') return false
            return this.checkGroupLink(msg, entities)
        },
        groupLinkStr() {
            const msg = this.msg ? this.msg : this.message.msg
            return this.getLinkStr(msg)
        },
        checkGroupLink(text, textEntities = []) {
            const isServerAPI_Ok = this[GET_SERVER_API] >= declarations.serverAPILevels.LEVEL_20
            if (!isServerAPI_Ok) return false
            if (!text) return false
            try {
                const isNewRefFormat = textEntities.some && textEntities.some(ent => ent.hasOwnProperty('type') && ent.type === "url")
                const isRoschatGroupLink = text.match(RE_ROSCHAT_GROUP_LINK)
                if (isRoschatGroupLink && isNewRefFormat) return true
            } catch (error) {
                return false
            }
            return false
        },
        getLinkStr(msgStr) {
            const checkMatch = msgStr.match(RE_ROSCHAT_GROUP_LINK)
            return checkMatch && checkMatch.groups['groupUrlString'] || ''
        },
        async getChatLinksInfo(message) {
            const isServerAPI_Ok = this[GET_SERVER_API] >= declarations.serverAPILevels.LEVEL_19
            if (!isServerAPI_Ok) return { error: true }
            const linksInfo = await this[ACT_CHAT_LINK_INFO]({ link: this.groupLinkStr(message) })
            return linksInfo
        },
        formGroupChatLinkContextMenu(groupLink, isValid = true, isPub) {
            let handlers = []
            if (isValid) handlers.push({ item_name: this.$t('chat.group-join-text'), handler: this.openJoinGroupModal, data: groupLink })
            handlers.push({ item_name: this.$t('copy-link'), handler: this.copyToClipboard, data: this.chatLinkUrl })
            if (!isPub) handlers.push({ item_name: this.$t('chat.delete'), handler: this.removeMsg, data: this.message })
            return handlers
        },
        groupLinkContextMenu(e, isPub = false) {
            let handlers = []
            let { event, groupLink } = e.detail
            if ('error' in this.chatLinksInfo) {
                handlers = this.formGroupChatLinkContextMenu('', false)
            } else {
                handlers = this.formGroupChatLinkContextMenu(groupLink, true, isPub)
            }
            this.cmOpen(event, handlers, 'right-bottom')
        },
        groupLinkClick(e) {
            document.querySelector('#app').__vue__.$refs.menu.close()
            if ('error' in this.chatLinksInfo) return
            let { groupLink } = e.detail
            this.openJoinGroupModal(groupLink)
        },
        copyToClipboard(data = '') {
            let { text, entities } = data
            let _text
            if (text) {
                if (entities) this[ACT_CHAT_SET_MSG_ENTITIES]({ text, entities })
                _text = text
            }
            else {
                _text = data
            }
            this.$copyText(_text, undefined, {
                sourceType: DLP_SOURCE_TYPES.CHAT_MESSAGE,
                sourceData: {
                    id: this.message.id,
                    cid: this.message.cid,
                    cidType: this.message.cidType,
                }
            })
        },        
        getModelSchMessageById(_taskId) {
            // console.log("🚀 ~ chat-message-mixin.js:700 ~ getSchMessageById ~ _taskId:", _taskId)
            const schMsg = this[GET_CHAT_SCH_MESSAGE_BY_ID](_taskId)
            // console.log("🚀 ~ chat-message-mixin.js:702 ~ getSchMessageById ~ schMsg:", schMsg)
            const { taskId, type, time, payload } = schMsg
            return { taskId, type, time, payload }
        },
        getScheduledUnixTime(date, time) {
            const _date = moment(date), _time = moment(time)
            _date.hours(_time.hours())
            _date.minutes(_time.minutes())
            _date.seconds(0)
            return _date.unix()
        },
        async updateSchMessage(schMessage) {
            await this[ACT_CHAT_UPDATE_SCH_MESSAGE](schMessage)
        },
        ...mapActions(AJAX, [
            ACT_AJAX_GET_FILE,
            ACT_ABORT_AJAX_CALL,
        ]),
        ...mapActions(CHAT, [
            ACT_CHAT_SET_MSG_ENTITIES,
            ACT_CHAT_UPDATE_SCH_MESSAGE,
            ACT_CHAT_LINK_INFO,
        ]),
    },
}

export default mixin